// extracted by mini-css-extract-plugin
module.exports = {"page-description":"PageDescription_page-description__q6Cww"};